import { Icon, symbolName } from './Icon'

type LanguageIconProps = Readonly<{
  size?: number
  color?: string
}>

export function LanguageIcon({
  size = 24,
  color = '#777777',
}: LanguageIconProps) {
  return (
    <Icon
      name={symbolName('character.book.closed', 'translate')}
      size={size}
      color={color}
    />
  )
}
